module.exports = __webpack_public_path__ + "static/home-offer-1-05e5798b35ef8d4e8ac27db10a64012c.webp";